import React, { useState } from 'react';
import styled from 'styled-components';

const UploadContainer = styled.div`
  position: relative;
  background-color: transparent;
  border-radius: 16px;
  border: 2px dashed rgba(255, 105, 180, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  text-align: center;
  width: 100%;
  height: 100%;
  min-height: 200px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  
  &:hover {
    border-color: var(--primary-color);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 105, 180, 0.2);
  }
  
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(255, 64, 192, 0.03) 0%, rgba(255, 208, 0, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
`;

const UploadIcon = styled.div`
  font-size: 52px;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 16px;
  z-index: 1;
`;

const UploadText = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-weight: 500;
  z-index: 1;
`;

const Upload = () => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    // Handle file drop
  };

  return (
    <UploadContainer
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <UploadIcon>☁️</UploadIcon>
      <UploadText>Trascina qui i file o clicca per caricare</UploadText>
    </UploadContainer>
  );
};

export default Upload; 